/**
 * A workaround/dirty hack, as it is easier to work with strings in our questionnaire forms.
 * */
enum QuestionnaireBoolean {
  true = 'true',
  false = 'false',
  undefined = 'undefined',
}

export default QuestionnaireBoolean;
